import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
} from '@mui/material';


const ModalConfirmation = ({
  open,
  onClose,
  title,
  onBtnClick,
  btnText,
  onCancelBtnClick,
} : {
  open: boolean;
  // eslint-disable-next-line no-unused-vars
  onClose: ((event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void) | undefined,
  title: string,
  onBtnClick: () => void,
  colorBtn: 'primary' | 'secondary' | 'inherit' | 'default',
  btnText: string,
  onCancelBtnClick: () => void,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogActions style={{
        justifyContent: 'center',
        paddingBottom: '20px',
      }}>
        <Button
          onClick={onBtnClick}
          color={'secondary'}
          variant="contained"
        >
          {btnText}
        </Button>
        <Button
          onClick={onCancelBtnClick}
          variant="contained"
        >
        Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalConfirmation;
